const localesConfig = {
  'es-AR': {
    url: process.env.HOP_URL_AR ? `https://${process.env.HOP_URL_AR}` : 'https://hopenvios.com.ar',
    dictionary: () => import('../locales/es-AR.json').then((module) => module.default)
  },
  'es-UY': {
    url: process.env.HOP_URL_UY ? `https://${process.env.HOP_URL_UY}` : 'https://hopenvios.com.uy',
    dictionary: () => import('../locales/es-UY.json').then((module) => module.default)
  },
  'es-PE': {
    url: process.env.HOP_URL_PE ? `https://${process.env.HOP_URL_PE}` : 'https://hopenvios.com.pe',
    dictionary: () => import('../locales/es-PE.json').then((module) => module.default)
  }
};

export default class localeManager {
  static detectLocale = (req, defaultLocale = 'es-AR') => {
    const invokePath = req.headers['x-invoke-path'] || '';
    const host = req.headers.host || '';

    if (invokePath.includes('es-UY') || host.endsWith('.uy')) {
      return 'es-UY';
    } else if (invokePath.includes('es-PE') || host.endsWith('.pe')) {
      return 'es-PE';
    } else if (invokePath.includes('es-AR') || host.endsWith('.ar')) {
      return 'es-AR';
    }

    return defaultLocale;
  };

  static getDictionary = async (locale = 'es-AR') => {
    if (!localesConfig[locale]) {
      console.warn(`Dictionary for locale ${locale} not found. Falling back to 'es-AR'.`);
      locale = 'es-AR';
    }

    return localesConfig[locale].dictionary();
  };

  static getBaseUrl = (locale = 'es-AR') => {
    if (!localesConfig[locale]) {
      console.warn(`Base URL for locale ${locale} not found. Falling back to 'es-AR'.`);
      locale = 'es-AR';
    }

    return localesConfig[locale].url;
  };

  static getResource = async (name, locale = 'es-AR') => {
    try {
      return await import(`../locales/resources/${locale}/${name}`).then(
        (module) => module.default
      );
    } catch (error) {
      console.error(`Resource ${name} for locale ${locale} not found.`);
      throw error;
    }
  };

  static getLocaleResources = async (
    req,
    options = {
      includeLocalidades: false,
      includeDistritos: false,
      includeProvincias: false,
      includeDepartamentos: false
    },
    defaultLocale = 'es-AR'
  ) => {
    const locale = this.detectLocale(req, defaultLocale);

    if (locale === 'es-PE') {
      options = {
        ...options,
        includeLocalidades: false,
        includeDistritos: true,
        includeProvincias: true,
        includeDepartamentos: true
      };
    }

    const promises = {
      dict: this.getDictionary(locale),
      localidades: options.includeLocalidades ? this.getResource('localidades.json', locale) : null,
      distritos: options.includeDistritos ? this.getResource('distritos.json', locale) : null,
      provincias: options.includeProvincias ? this.getResource('provincias.json', locale) : null,
      departamentos: options.includeDepartamentos
        ? this.getResource('departamentos.json', locale)
        : null
    };

    const results = await Promise.allSettled(
      Object.entries(promises).map(([key, promise]) =>
        promise ? promise.catch(() => null) : Promise.resolve(null)
      )
    );

    const [dict, localidades, distritos, provincias, departamentos] = results.map((result) =>
      result.status === 'fulfilled' ? result.value : null
    );

    return {
      locale,
      dict,
      resources: {
        localidades: options.includeLocalidades ? localidades : null,
        distritos: options.includeDistritos ? distritos : null,
        provincias: options.includeProvincias ? provincias : null,
        departamentos: options.includeDepartamentos ? departamentos : null
      }
    };
  };
}
